import React from 'react';
import DashboardButton from './DashboardButton';
import PlusIcon from '/src/assets/images/button/check-square.svg?url';

const ButtonAccept: React.FC = () => (
  <DashboardButton
    badge
    label="تایید شده"
    width={95}
    height={28}
    backgroundColor="transparent"
    textColor="#059669"
    startIcon={
      <img
        src={PlusIcon}
        alt="loading Icon"
        style={{ width: '20px', height: '20px' }}
      />
    }
  />
);

export default ButtonAccept;
